module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/e0d7d5cdcdc5e9f9b1efb87710341270.png";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/past_certificates/bronze.png
// module id = sJxe
// module chunks = 0